import React from 'react';
import { Modal } from 'antd';
import { RichTextDescription } from '../index';
import type { MarkdownMentionPreviewContext, ShortcutConfig } from '../types';
import styles from './DescriptionModal.module.css';

export type DescriptionModalProps = {
  open: boolean;
  onClose: () => void;
  value: string;
  onChange: (value: string) => void;
  onSave?: (value: string) => void;
  shortcutConfig?: ShortcutConfig | null;
  title?: string;
  getContainer?: () => HTMLElement;
  mentionRenderContext?: MarkdownMentionPreviewContext | null;
  show?: boolean;
};

export const DescriptionModal = ({
  open,
  onClose,
  value,
  onChange,
  onSave,
  shortcutConfig,
  title = 'Task Description',
  getContainer,
  mentionRenderContext = null,
  show = true
}: DescriptionModalProps) => {
  const [draftValue, setDraftValue] = React.useState(value);

  React.useEffect(() => {
    if (open) {
      setDraftValue(value);
    }
  }, [open, value]);

  const handleCancel = () => {
    onClose();
  };

  const handleOk = () => {
    if (onSave) {
      onSave(draftValue);
    }
    onClose();
  };

  if (!show) return null;

  return (
    <Modal
      title={title}
      open={open}
      onCancel={handleCancel}
      onOk={handleOk}
      okText="Save"
      cancelText="Cancel"
      width={640}
      destroyOnClose
      className={styles.modal}
      bodyStyle={{ paddingTop: 0 }}
      getContainer={getContainer}
    >
      <div className={styles.modalContent} data-description-modal>
        <RichTextDescription
          value={draftValue}
          onChange={setDraftValue}
          shortcutConfig={shortcutConfig}
          fullHeight
          mentionRenderContext={mentionRenderContext}
        />
      </div>
    </Modal>
  );
};
